export default defineNuxtRouteMiddleware(async (to, _from) => {
  if (import.meta.server) return

  // Handle trailing slashes by redirecting to the non-trailing slash version
  if (to.path !== '/' && to.path.endsWith('/')) {
    return navigateTo(to.path.slice(0, -1), { replace: true })
  }

  const { initialize } = useUser()
  await initialize()
})
